import React from 'react';
import { differenceInSeconds } from 'date-fns';
import Time from './Time';

export default class extends React.Component {

    constructor(props) {
        super(props);
        this.state = { gameTime: 0 };
    }

    componentDidMount() {
        this.timer = setInterval(this.tick.bind(this), 1000);
        this.tick();
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    tick() {
        const { isPaused, startedAt, pausedAt, pausedFor } = this.props.status;
        const gameTime = isPaused
            ? differenceInSeconds(pausedAt, startedAt) - pausedFor
            : differenceInSeconds(new Date(), startedAt) - pausedFor;

        this.setState({ gameTime });
    }

    render() {
        return (
            <li className="timeline__item timeline__item--clock">
                <div className="event event--flow"><Time time={this.state.gameTime}/></div>
            </li>
        );
    }
}
